export default __webpack_public_path__ + "static/media/app_logo_small.c0318c1c.png";